// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"db01dd8d","317":"0c461792","787":"3df59d24"}[chunkId] + ".chunk.js";
};